(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ol-header"]) return;
  try {
    

if (!customElements.get('ol-announcements')) {
  customElements.define('ol-announcements', class extends HTMLElement {
    connectedCallback() {
      this.applyDates();
      this.trackHeight();
      this.messages = [...this.querySelectorAll('[data-announcement-id]:not([hidden])')];
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.editing = false;
      this.button = this.querySelector('.ol-announcement-toggle');
      if (this.messages.length < 2) return;
      this.show(0, true);
      this.button.setAttribute('aria-pressed', 'false');
      this.button.setAttribute('aria-label', this.button.dataset.pauseLabel);
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.rotate = this.dataset.rotate === 'true';
      this.interval = Math.min(10000, Math.max(2000, Number(this.dataset.interval) || 5000));
      this.halfFade = Math.min(800, Math.max(0, Number(this.dataset.fade) || 0)) / 2;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.addEventListener('pointerenter', () => { this.hovered = true; this.stop(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      this.button.addEventListener('click', () => {
        this.paused = !this.paused;
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.stop();
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => { this.stop(); this.schedule(); }, options);
      this.motion.addEventListener('change', () => { this.stop(); this.updateControls(); this.schedule(); }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.messages.findIndex(message => message.dataset.announcementId === event.detail.blockId);
        if (index < 0) return;
        this.editing = true;
        this.stop();
        this.show(index, true);
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.editing = false;
        if (!this.rotate) this.show(0, true);
        this.schedule();
      }, options);
      this.updateControls();
      this.schedule();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.fadeTimer);
      this.abort?.abort();
      this.heightObserver?.disconnect();
      this.heightObserver = null;
    }
    trackHeight() {
      // the strip's height, for anchor jumps and the parts of pages that pin themselves below it
      if (this.heightObserver || !window.ResizeObserver) return;
      const set = () => document.documentElement.style.setProperty('--ol-strip-h', this.offsetHeight + 'px');
      this.heightObserver = new ResizeObserver(set);
      this.heightObserver.observe(this);
      set();
    }
    applyDates() {
      if (window.Shopify && Shopify.designMode) return;
      const all = [...this.querySelectorAll('[data-announcement-id]')];
      const now = Date.now() / 1000;
      const live = all.filter(m => now >= Number(m.dataset.from || 0) && now <= Number(m.dataset.until || Infinity));
      const shown = live.some(m => m.hasAttribute('data-only')) ? live.filter(m => m.hasAttribute('data-only')) : live;
      all.forEach(m => {
        m.hidden = !shown.includes(m);
        m.classList.toggle('is-active', m === shown[0]);
        m.setAttribute('aria-hidden', String(m !== shown[0]));
      });
      this.hidden = !shown.length;
    }
    updateControls() {
      const enabled = this.rotate && !this.motion.matches && this.dataset.pauseButton === 'true';
      this.button.hidden = !enabled;
      this.toggleAttribute('data-controls', enabled);
    }
    canRotate() {
      return this.isConnected && this.rotate && !this.motion.matches && !this.paused && !this.hovered && !this.focused && !this.editing && !document.hidden;
    }
    schedule(delay = this.interval) {
      clearTimeout(this.timer);
      if (this.canRotate()) this.timer = setTimeout(() => this.advance(), delay);
    }
    stop() {
      clearTimeout(this.timer);
      clearTimeout(this.fadeTimer);
      this.show(this.index, true);
    }
    show(index, instant = false) {
      if (instant) this.classList.add('is-instant');
      this.index = index;
      this.messages.forEach((message, i) => {
        message.classList.remove('is-leaving');
        message.classList.toggle('is-active', i === index);
        message.setAttribute('aria-hidden', String(i !== index));
      });
      if (instant) {
        void this.offsetHeight;
        this.classList.remove('is-instant');
      }
    }
    advance() {
      if (!this.canRotate()) return;
      this.messages[this.index].classList.add('is-leaving');
      this.messages[this.index].classList.remove('is-active');
      this.fadeTimer = setTimeout(() => {
        this.show((this.index + 1) % this.messages.length);
        this.schedule(this.interval - this.halfFade);
      }, this.halfFade);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ol-location-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialise(root) {
      root.querySelectorAll('[data-ol-directory]').forEach(directory => {
        const controls = directory.querySelector('[data-ol-location-filters]');
        const entries = [...directory.querySelectorAll('[data-ol-place]')];
        if (!controls || controls.dataset.ready || entries.length < 2) return;
        controls.dataset.ready = 'true';
        const search = controls.querySelector('[data-ol-location-search]');
        const areas = controls.querySelector('[data-ol-location-area]');
        const count = controls.querySelector('[data-ol-location-count]');
        const index = entries.map(element => ({element, text: element.textContent.toLocaleLowerCase(), area: element.dataset.area}));
        [...new Set(index.map(item => item.area).filter(Boolean))].sort().forEach(area => areas.add(new Option(area, area)));
        areas.closest('label').hidden = areas.options.length < 3;
        const update = () => {
          const query = search.value.trim().toLocaleLowerCase();
          let visible = 0;
          index.forEach(item => {
            item.element.hidden = Boolean((areas.value && item.area !== areas.value) || (query && !item.text.includes(query)));
            if (!item.element.hidden) visible++;
          });
          count.textContent = count.dataset.countTemplate.replace('__COUNT__', String(visible));
          directory.querySelector('[data-ol-location-empty]').hidden = visible > 0;
        };
        search.addEventListener('input', update);
        areas.addEventListener('change', update);
        controls.querySelector('[data-ol-location-reset]').addEventListener('click', () => {search.value = ''; areas.value = ''; update(); search.focus();});
        controls.hidden = false;
        update();
      });
    }
    initialise(document);
    document.addEventListener('shopify:section:load', event => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
